export default __webpack_public_path__ + "static/media/Wheel-Wedge-Blue.2a5237d3.png";